<mat-card cdk-scrollable>
  <mat-card-header>
    <mat-card-title> Wydruk KPO </mat-card-title>
    <mat-card-subtitle>
      Pobieranie KPO o statusie "Zrealizowane przejęcie" lub "Potwierdzony transport" jako pliki PDF* <br /><br />
      ( * ) KPO doładowywane są cyklicznie z urzędowej bazy. Karta, której szukasz może pojawić się w wykazie z kilkuminutowym opóźnieniem.
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <app-bdo-filter> </app-bdo-filter>

    <mat-spinner *ngIf="loading" style="margin: 90px auto"></mat-spinner>

    <ng-container>
      <ng-container *ngFor="let item of filteredResults">
        <mat-accordion>
          <app-card-block [details]="item" [check]="true" [header]="item.wasteTransferCard.cardNumber" (checked)="item.checked = $event" [checkboxChecked]="item.checked" class="green-label">
            <div fxLayout="row wrap">
              <app-card-block-field header="Kod odpadów" fxFlex="50%" fxFlex.gt-lg="50%">
                {{ item.wasteTransferCard.wasteCode }}
              </app-card-block-field>
              <app-card-block-field header="Nazwa przejmującego" *ngIf="item.wasteTransferCard.receiverName" fxFlex="50%" fxFlex.gt-lg="50%">
                {{ item.wasteTransferCard.receiverName }}
              </app-card-block-field>
              <app-card-block-field header="Masa odpadów" *ngIf="item.wasteTransferCardDetails.wasteMass" fxFlex="50%" fxFlex.gt-lg="50%">
                {{ item.wasteTransferCardDetails.wasteMass }}
              </app-card-block-field>

              <app-card-block-field header="Data przekazania" fxFlex="50%" fxFlex.gt-lg="50%">
                {{ item.wasteTransferCardDetails.transportConfirmationTime | date : "dd.MM.yyyy HH:mm" }}
              </app-card-block-field>
            </div>
            <!-- <button mat-button color="primary" [matMenuTriggerFor]="menu"
                              class="actions-menu">Akcje</button>
                          <mat-menu #menu="matMenu">
                              <button (click)="openDetailsDialog(item)" mat-menu-item>Podgląd</button>
                          </mat-menu> -->
          </app-card-block>
        </mat-accordion>
      </ng-container>
    </ng-container>
    <mat-paginator [pageSize]="50" [pageSizeOptions]="[10, 20, 30, 50, 100, 200, 500, 1000]"></mat-paginator>
    <mat-card-actions style="text-align: right">
      <button mat-flat-button color="secondary" style="margin: 8px" (click)="selectAll()">Zaznacz wszystkie na stronie</button>
      <button mat-flat-button color="primary" style="margin: 8px" (click)="exportSelected()" [disabled]="isWorking || selectedCount() === 0">Pobierz zaznaczone ({{ selectedCount() }})</button>
      <button mat-flat-button color="primary" style="margin: 8px" (click)="exportFiltered()" [disabled]="isWorking || loading || totalItemCount === 0">Pobierz wszystkie wyfiltrowane ({{ totalItemCount }})</button>
    </mat-card-actions>

    <div class="exports" *ngIf="exports.length">
      <h3>Eksporty</h3>
      <p class="exports-hint">
        Pliki PDF w archiwum mają nazwy według numeru KPO. Plik zestawienie.csv zawiera listę kart z informacjami dodatkowymi. Karty pobrane wcześniej trafiają do archiwum od razu, bez ponownego odpytywania BDO. Archiwa są usuwane po 7 dniach.
      </p>
      <div class="export-item" *ngFor="let job of exports">
        <div class="export-header">
          <div>
            <div class="export-title">{{ job.createdAt | date : "dd.MM.yyyy HH:mm" }} &middot; {{ job.totalCount }} kart</div>
            <div class="export-description">{{ job.description }}</div>
          </div>
          <div class="export-actions">
            <button mat-stroked-button *ngIf="isActive(job)" (click)="cancelExport(job)">Anuluj</button>
            <button mat-flat-button color="primary" *ngIf="job.status === exportStatus.Completed" (click)="downloadExport(job)">Pobierz ZIP {{ fileSizeLabel(job.fileSize) }}</button>
          </div>
        </div>
        <mat-progress-bar *ngIf="isActive(job)" [mode]="job.status === exportStatus.Pending ? 'query' : 'determinate'" [value]="progress(job)"></mat-progress-bar>
        <div class="export-status" [class.error]="job.status === exportStatus.Failed || job.failedCount > 0">{{ statusLabel(job) }}</div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
